var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIconSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/headphone"
  }, /*#__PURE__*/React.createElement("g", {
    id: "headphone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.60751 18.4898V15.5698C5.60751 14.5998 6.36751 13.7298 7.44751 13.7298C8.41751 13.7298 9.28751 14.4898 9.28751 15.5698V18.3798C9.28751 20.3298 7.66751 21.9498 5.71751 21.9498C3.76751 21.9498 2.14751 20.3198 2.14751 18.3798V12.2198C2.03751 6.5998 6.47751 2.0498 12.0975 2.0498C17.7175 2.0498 22.1475 6.5998 22.1475 12.1098V18.2698C22.1475 20.2198 20.5275 21.8398 18.5775 21.8398C16.6275 21.8398 15.0075 20.2198 15.0075 18.2698V15.4598C15.0075 14.4898 15.7675 13.6198 16.8475 13.6198C17.8175 13.6198 18.6875 14.3798 18.6875 15.4598V18.4898",
    stroke: "#2065B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconSupport);
export default __webpack_public_path__ + "static/media/profile-icon-support.dff0c312c4ebdf574ef2a7f1442b16c9.svg";
export { ForwardRef as ReactComponent };